import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { Header } from "@/components/promill/Header";
import { Hero } from "@/components/promill/Hero";
import { ValuePillars } from "@/components/promill/ValuePillars";
import { FeaturedProducts } from "@/components/promill/FeaturedProducts";
import { HowItWorks } from "@/components/promill/HowItWorks";
import { NutritionStrip } from "@/components/promill/NutritionStrip";
import { Lifestyle } from "@/components/promill/Lifestyle";
import { Testimonials } from "@/components/promill/Testimonials";
import { Newsletter } from "@/components/promill/Newsletter";
import { Footer } from "@/components/promill/Footer";
import MenuPage from "@/pages/MenuPage";
import StoresPage from "@/pages/StoresPage";
import AboutPage from "@/pages/AboutPage";
import FoodPromisePage from "@/pages/FoodPromisePage";
import ContactPage from "@/pages/ContactPage";
import FAQPage from "@/pages/FAQPage";
import NutritionPage from "@/pages/NutritionPage";
import FranchisePage from "@/pages/FranchisePage";
import LegalPage from "@/pages/LegalPage";
import AdminPage from "@/pages/AdminPage";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);
    return null;
};

const Home = () => (
    <div data-testid="home-page" className="bg-pm-cream min-h-screen text-pm-black">
        <Header />
        <main>
            <Hero />
            <ValuePillars />
            <FeaturedProducts />
            <HowItWorks />
            <NutritionStrip />
            <Lifestyle />
            <Testimonials />
            <Newsletter />
        </main>
        <Footer />
    </div>
);

function App() {
    return (
        <div className="App">
            <CartProvider>
                <BrowserRouter>
                    <ScrollToTop />
                    <Toaster position="top-center" richColors />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/menu" element={<MenuPage />} />
                        <Route path="/stores" element={<StoresPage />} />
                        <Route path="/food-promise" element={<FoodPromisePage />} />
                        <Route path="/about" element={<AboutPage />} />
                        <Route path="/franchise" element={<FranchisePage />} />
                        <Route path="/contact" element={<ContactPage />} />
                        <Route path="/faqs" element={<FAQPage />} />
                        <Route path="/nutrition" element={<NutritionPage />} />
                        <Route path="/legal/:slug" element={<LegalPage />} />
                        <Route path="/admin" element={<AdminPage />} />
                        {/* Legacy /build route → redirect to menu (page hidden per client) */}
                        <Route path="/build" element={<Navigate to="/menu" replace />} />
                    </Routes>
                </BrowserRouter>
            </CartProvider>
        </div>
    );
}

export default App;
